module.exports = __webpack_public_path__ + "static/media/05_tatibana13abc10f4292f67c75773eada1302896.webp";